import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';
import { commonState_IsSending, commonState_LatestJourney } from 'src/app/store/common/common.selectors';
import { GoToStepAction } from '../../actions';
import { AppButtonComponent, EntryCheckboxFieldComponent, Helper } from '@ifaa-components/ui-components';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { termsConditions_Form } from './selectors';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppButtonDirective } from 'src/app/directives/appbutton.directive';
import { NgrxFormsModule } from 'ngrx-forms';

@Component({
    selector: 'app-nmj-terms-conditions',
    templateUrl: './nmj-terms-conditions.component.html',
    styleUrls: ['./nmj-terms-conditions.component.scss'],
    imports: [
        AsyncPipe,
        AppButtonComponent,
        ReactiveFormsModule,
        NgrxFormsModule,
        FormsModule,
        EntryCheckboxFieldComponent,
        NgIf,
        NgTemplateOutlet,
        AppButtonDirective
    ],
})
export class NmjTermsConditionsComponent extends ComponentBase implements OnInit, OnDestroy {

    @Input() set step(value: number) {
        this.stepIndex = value;
    }

    isLoading$ = this.store.pipe(select(commonState_IsSending));
    journeySteps$ = this.store.pipe(select(commonState_LatestJourney));
    form$ = this.store.pipe(select(termsConditions_Form));

    stepIndex: number = 0;
    nextStep: number = 0;
    previousStep: number = 0;

    helper:Helper = new Helper();

    constructor(public store: Store<AppState>) {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();

        this.sub = this.journeySteps$.subscribe(async x => {
            if (x) {
                this.nextStep = (await this.helper.getValue(this.journeySteps$)).journeySteps.filter(x => x.journeyStep > this.stepIndex)[0]?.journeyStep ?? -1;
                this.previousStep = (await this.helper.getValue(this.journeySteps$)).journeySteps.filter(x => x.journeyStep < this.stepIndex).sort((a, b) => b.journeyStep - a.journeyStep)[0].journeyStep;
            }
        })
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }

    async onMoveBackClick() {
        this.store.dispatch(GoToStepAction({ index: this.previousStep }))
    }

    async onMoveNextClick() {
        // go next step
        this.store.dispatch(GoToStepAction({ index: this.nextStep }));
    }
}
